export default __webpack_public_path__ + "static/media/AI_human_handshake.1db7e9bf.svg";